// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageBackground_wrapper___Aci7","wrapperWithBreadcrumbs":"PageBackground_wrapperWithBreadcrumbs__pYIW5","imageFlipped":"PageBackground_imageFlipped__nw3qe"};